import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Button, Row, Col, Form, Spinner, Modal, Card } from 'react-bootstrap';
import { FaDownload, FaSearch, FaEraser } from 'react-icons/fa';
import api from '../../api/apiweb-skualo.js';
import './Skualo.scss';

const todosCajero = { label: 'Todos', value: '' };

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: state.isFocused ? '#2563eb' : '#cbd5e1',
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(37, 99, 235, 0.15)' : 'none',
    '&:hover': { borderColor: '#2563eb' },
  }),
};

function Skualo(props) {
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10);
  });
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [device, setDevice] = useState(todosCajero);
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [modalDescarga, setModalDescarga] = useState(false);
  const [modalDescargaMensaje, setModalDescargaMensaje] = useState('');
  const [mensajeFallo, setMensajeFallo] = useState(false);
  const [descargando, setDescargando] = useState(false);

  const handleSearch = () => {
    if (!startDate || !endDate) {
      setMensajeFallo(true);
      setModalDescargaMensaje('Debes seleccionar ambas fechas');
      setModalDescarga(true);
      return;
    }
    if (startDate > endDate) {
      setMensajeFallo(true);
      setModalDescargaMensaje('La fecha inicial no puede ser mayor que la final');
      setModalDescarga(true);
      return;
    }

    setMensajeFallo(false);
    setDescargando(true);
    setModalDescarga(true);
    setModalDescargaMensaje('Descargando…');

    const params = { startDate, endDate };
    if (device.value !== '') params.device_id = device.value;

    api.download(params, (state, message) => {
      setDescargando(false);
      if (state) {
        setModalDescarga(false);
        setModalDescargaMensaje('');
      } else {
        if (message === 'Error en la descarga') {
          setModalDescargaMensaje(message);
          setMensajeFallo(true);
        } else {
          setModalDescargaMensaje(message);
        }
        setModalDescarga(true);
      }
    });
  };

  const limpiar = () => {
    const today = new Date();
    setStartDate(new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10));
    setEndDate(today.toISOString().slice(0, 10));
    setDevice(todosCajero);
  };

  const closeModal = () => setModalDescarga(false);

  useEffect(() => {
    const devices = props.devices;
    const array = [{ label: 'Todos', value: '' }];
    if (Array.isArray(devices)) {
      devices.forEach((element) => {
        array.push({ label: element.name, value: element.device_id });
      });
      setDeviceOptions(array);
    }
  }, [props.devices]);

  return (
    <div className="Skualo">
      <div className="page-header">
        <h1 className="page-title">Skualo</h1>
        <p className="page-subtitle">Descarga documentos por rango de fechas y cajero</p>
      </div>

      <Card className="search-card">
        <Card.Header className="search-card-header">
          <FaSearch className="me-2" />
          Filtros de descarga
        </Card.Header>
        <Card.Body>
          <Row className="g-3">
            <Col sm={12} md={4}>
              <Form.Label>Fecha inicio</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>
            <Col sm={12} md={4}>
              <Form.Label>Fecha fin</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>
            <Col sm={12} md={4}>
              <Form.Label>Cajero</Form.Label>
              <Select
                options={deviceOptions}
                value={device}
                onChange={(e) => setDevice(e)}
                styles={selectStyles}
                placeholder="Todos los cajeros"
              />
            </Col>
          </Row>

          <div className="search-actions">
            <Button variant="primary" onClick={handleSearch} disabled={descargando}>
              <FaDownload className="me-2" />Buscar y descargar
            </Button>
            <Button variant="outline-secondary" onClick={limpiar} className="ms-auto">
              <FaEraser className="me-2" />Limpiar
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal show={modalDescarga} onHide={closeModal} centered>
        <Modal.Header closeButton={mensajeFallo}>
          <Modal.Title>Descarga de documentos</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          {!mensajeFallo && <Spinner animation="border" variant="primary" className="mb-3" />}
          <div className="modal-message">{modalDescargaMensaje}</div>
        </Modal.Body>
        {mensajeFallo && (
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>Cerrar</Button>
          </Modal.Footer>
        )}
      </Modal>
    </div>
  );
}

export default Skualo;
